<template>
  <div id="serviciosExternos">
    <div class="card">
      <div class="card-body">
        <h4 class="fw-bolder mb-4">Servicios Externos</h4>
        <div class="text-right"></div>
        <div v-if="loading" class="text-center">
          <div class="loadingio-spinner-ripple-6armq16mc04">
            <div class="ldio-2tzb8vdk7pu">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            <div v-if="permiso" class="text-end">
              <button
                data-bs-toggle="modal"
                data-bs-target="#nueva_servicio_externo"
                class="btn btn-success btn-sm btn-rounded btn-icon-text"
              >
                <i class="fa fa-plus-circle"></i> Nuevo
              </button>
            </div>
            <div class="input-group mt-2 mb-2 mr-sm-2">
              <input
                v-model="search"
                v-on:keyup="get_serviciosExternos"
                type="text"
                class="form-control"
                placeholder="Buscar servicio externo"
              />
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-search"></i>
                </div>
              </div>
            </div>
            <div v-if="servicios_externos.length != 0" class="mt-3">
              <div
                class="card card-body card-reservas shadow border mb-3"
                v-for="(
                  servicioExterno, index_servicio_externo
                ) in servicios_externos"
                v-bind:key="index_servicio_externo"
              >
                <div class="text-end">
                  <label
                    v-if="servicioExterno.estado_servicio == 1"
                    class="text-success"
                    >Activa</label
                  >
                  <label
                    v-if="servicioExterno.estado_servicio == 0"
                    class="text-danger"
                    >Inactiva</label
                  >
                </div>
                <div class="form-group">
                  <small>Servicio externo</small><br />
                  <small class="text-muted fw-bolder">{{
                    servicioExterno.codigo
                  }}</small>
                  <h6>
                    <router-link
                      v-bind:to="
                        '/servicio_externo/' + servicioExterno.id_servicio
                      "
                    >
                      <strong>{{
                        servicioExterno.servicio
                      }}</strong></router-link
                    >
                  </h6>
                </div>
                <div class="text-end">
                  <router-link
                    v-bind:to="
                      '/servicio_externo/' + servicioExterno.id_servicio
                    "
                    class="btn btn-primary btn-rounded btn-xs"
                    title="Detalles"
                  >
                    <i class="fa fa-list"></i>
                  </router-link>

                  <button
                    v-if="servicioExterno.estado_servicio == 0 && permiso"
                    v-on:click="
                      update_estado_servicio_externo(index_servicio_externo)
                    "
                    class="btn btn-warning btn-rounded btn-xs ms-1"
                    title="Activar"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                  <button
                    v-if="servicioExterno.estado_servicio == 1 && permiso"
                    v-on:click="
                      update_estado_servicio_externo(index_servicio_externo)
                    "
                    class="btn btn-outline-warning btn-rounded btn-xs ms-1"
                    title="Desactivar"
                  >
                    <i class="fa fa-eye-slash"></i>
                  </button>
                  <button
                    v-if="servicioExterno.destacado == 1 && permiso"
                    v-on:click="
                      update_destacada_servicio_externo(index_servicio_externo)
                    "
                    class="btn btn-warning btn-rounded btn-xs ms-1"
                    title="No destacar"
                  >
                    <i class="fa fa-star"></i>
                  </button>
                  <button
                    v-if="servicioExterno.destacado == 0 && permiso"
                    v-on:click="
                      update_destacada_servicio_externo(index_servicio_externo)
                    "
                    class="btn btn-outline-warning btn-rounded btn-xs ms-1"
                    title="Destacar"
                  >
                    <i class="fa fa-star"></i>
                  </button>
                  <button
                    v-if="permiso"
                    v-on:click="delete_servicio_externo(index_servicio_externo)"
                    class="btn btn-danger btn-rounded btn-xs ms-1"
                    title="Eliminar"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

              <div class="text-center mt-3 mb-2" v-html="paginate"></div>
            </div>
            <div v-else>
              <div class="text-muted mt-4">
                <i class="fa-solid fa-circle-info"></i> No se han agregado
                servicios externos.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="nueva_servicio_externo">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-primary">
            <h5 class="modal-title fw-bolder">Nueva servicio externo</h5>
            <button
              id="close_modal_set"
              type="button"
              class="close"
              data-bs-dismiss="modal"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Destino</label>
              <v-select
                v-model="nueva.destino"
                @search="get_ciudades"
                label="ciudad_pais"
                :options="ciudades"
                :clearable="false"
              ></v-select>
            </div>
            <div class="form-group">
              <label>Nombre del servicio externo</label>
              <input
                v-model="nueva.servicio"
                type="text"
                class="form-control"
              />
            </div>
            <div class="text-end">
              <button
                v-on:click="set_servicio_externo"
                class="btn btn-success btn-rounded btn-sm btn-icon-text"
              >
                <i class="fa fa-save"></i> Guardar
              </button>
              <button
                data-bs-dismiss="modal"
                class="btn btn-outline-dark btn-rounded btn-sm btn-icon-text ms-1"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "ServiciosExternos",
  metaInfo: {
    title: "Servicios Externos - Backoffice",
  },
  data() {
    return {
      loading: true,
      page: 1,
      search: null,
      servicios_externos: [],

      ciudades: [],
      paginate: null,
      nueva: {
        destino: null,
        servicio: null,
      },
      servicio_sel: null,
      permiso: false,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.page = this.$route.params.page;
    this.get_serviciosExternos();
    this.permiso = this.session.usuario.usuario.permisos.GSERVICIOS;
  },
  methods: {
    get_serviciosExternos: function () {
      const vm = this;
      var search = null;
      if (this.search != null && this.search.length > 3) {
        search = this.search;
        if (this.page != 1) {
          this.page = 1;
          this.$router.push("/serviciosExternos/1");
        }
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": vm.$api_key,
      };
      let config = {
        headers: headers,
        params: {
          page: this.page,
          search: search,
        },
      };
      axios
        .get(vm.$base_url + "servicios/serviciosExternos", config, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status) {
            vm.servicios_externos = response.data.data.servicios_externos;
            vm.get_paginate(response.data.data.total_pages);
            vm.loading = false;
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicios externos",
              text: response.data.message,
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Servicios externos",
            text: error,
          });
          vm.loading = false;
        });
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;

      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'> <i class='fa fa-chevron-left'></i> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/servicios_externos/1' class='page-link' href='javascript:void(0);'> <i class='fa fa-chevron-left'></i> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/servicios_externos/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'> <i class='fa fa-chevron-left'></i> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/servicios_externos/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/servicios_externos/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/servicios_externos/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/servicios_externos/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/servicios_externos/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/servicios_externos/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <i class='fa fa-chevron-right'></i> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <i class='fa fa-chevron-right'></i> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
    get_ciudades: function (search) {
      if (search.length < 3) {
        return false;
      }
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": vm.$api_key,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(vm.$base_url + "destinos/ciudades", config, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status) {
            vm.ciudades = response.data.data.ciudades;
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicios externos",
              text: response.data.message,
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Servicios externos",
            text: error,
          });
          vm.loading = false;
        });
    },
    get_destinos: function (search) {
      if (search.length <= 3) {
        return false;
      }
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": vm.$api_key,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(vm.$base_url + "servicios/destino_search", config, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status) {
            vm.destinos = response.data.data.destinos;
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicios externos",
              text: response.data.message,
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Servicios externos",
            text: error,
          });
          vm.loading = false;
        });
    },
    set_servicio_externo: function () {
      const vm = this;
      var valida = true;

      if (
        this.nueva.servicio == null ||
        this.nueva.servicio.trim().length == 0
      ) {
        vm.$notify({
          group: "foo",
          type: "error",
          title: "Servicios Externos",
          text: "Digita el nombre del servicio.",
        });
        valida = false;
      }
      if (!valida) {
        return false;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        destino: this.nueva.destino,
        servicio: this.nueva.servicio,
      };
      axios
        .post(this.$base_url + "servicios/set_servicio_externo", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicios Externos",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Servicios Externos",
              text: response.data.message,
            });
          }
          vm.get_serviciosExternos();
          vm.nueva = {
            destino: null,
            servicio: null,
          };
        })
        .catch((error) => {
          vm.error_manager(error);
        })
        .finally();
    },
    update_estado_servicio_externo: function (index_servicio_externo) {
      var estado = 1;
      if (
        this.servicios_externos[index_servicio_externo].estado_servicio == 1
      ) {
        estado = 0;
      }
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        id_servicio:
          this.servicios_externos[index_servicio_externo].id_servicio,
        estado: estado,
      };
      axios
        .post(this.$base_url + "servicios/update_estado_servicio", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicios Externos",
              text: response.data.message,
            });
          }
          vm.get_serviciosExternos();
        })
        .catch((error) => {
          vm.error_manager(error);
        })
        .finally();
    },
    delete_servicio_externo: function (index_servicio_externo) {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        id_servicio:
          this.servicios_externos[index_servicio_externo].id_servicio,
      };
      axios
        .post(this.$base_url + "servicios/delete_servicio", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicios Externos",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Servicios Externos",
              text: response.data.message,
            });
          }
          vm.get_serviciosExternos();
        })
        .catch((error) => {
          vm.error_manager(error);
        })
        .finally();
    },
    error_manager: function (error) {
      let vm = this;
      let message = error;
      if (error.response.status != undefined && error.response.status == 401) {
        message = error.response.data.message;
        localStorage.removeItem("sess_vyt_backoffice");
        location.reload();
      }
      vm.$notify({
        group: "foo",
        type: "error",
        title: "Error",
        text: message,
      });
    },
  },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.get_serviciosExternos();
    },
  },
};
</script>
